/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

'use strict';

angular.module('webReader')
    .directive('notesList', function() {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            templateUrl: 'directives/noteslist/noteslist.view.html',
            controller: ["$scope", "NotesModel", "NotesService", "DocumentModel", "HighlightsService", "HighlightsModel", function($scope, NotesModel, NotesService, DocumentModel, HighlightsService, HighlightsModel) {
                var scope = $scope;
                scope.data = {
                    highlight: [],
                    notes: []
                };

                //@todo: move those ugly ifs into new configuration service
                NotesModel.create();

                NotesService.subscribe.onNotesChange(function() {
                    scope.data.notes = NotesService.getNotes();

                });
                HighlightsService.subscribe.onHighlightsChange(function() {
                    scope.data.highlight = HighlightsService.getHighlights();

                });
            }]
        };
    });